/* eslint-disable react/no-array-index-key */
import React from 'react'
import { t, Trans } from '@lingui/macro'
import PropTypes from 'prop-types'

import AppLinkContent from '../AppLinkContent'
import ImageTextSection from '../../../../components/common/ImageTextSection'

const heading = t`Download the free Yoti app on your smartphone`
const toggled = true
const canBeToggled = true
const paragraphs = [
  <Trans><p>Visit the App Store for iOS or Google Play for Android.</p></Trans>
]
const contentGenerator = props => <AppLinkContent {...props} />

const DownloadYotiStep = ({ device }) => (
  <ImageTextSection
    contentToggled={toggled}
    contentToggleEnabled={canBeToggled}
  >
    <h6 className="instructions-section__header">
      <Trans id={heading} />
    </h6>
    { paragraphs.map((p, key) => React.cloneElement(p, { key }))}
    {contentGenerator({ device })}
  </ImageTextSection>
)

DownloadYotiStep.propTypes = {
  device: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default DownloadYotiStep
